/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_extent_agg.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Calculate the spatial extent over a field with geometry type. Returns a bounding box for all values of the field.',
  examples: [
    'FROM airports\n| WHERE country == "India"\n| STATS extent = ST_EXTENT_AGG(location)',
  ],
  params: {
    field: '',
  },
};

export default docs;
